export const parseFiniteNumber = (
  value: string | null | undefined
): number | null => {
  if (value == null || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
